import gql from 'graphql-tag'

const QUERY = gql`
  query StoresForCentre($slugQuery: String!) {
    centres(limit: 1, q: $slugQuery) {
      title
      slug
      stores: _backrefs {
        entries: stores__via__centre(limit: 999) {
          sys {
            id
          }
          legacyIdentifier
          hideAt
          showAt
          paymentMethods
          title: titleWithOptionalStatus
          slug
          longDescription
          landmarkDescription
          callsToAction {
            category
            address
          }
          experiences {
            title
            slug
          }
          heroImageSet {
            standard {
              title
              description
              url
            }
            master {
              title
              description
              url
            }
          }
          retailer {
            longDescription
            paymentMethods
            callsToAction {
              category
              address
            }
            experiences {
              title
              slug
            }
            retailerLogoSet {
              backendTitle
              coloured {
                title
                url
              }
            }
            heroImageSet {
              standard {
                title
                description
                url
              }
              master {
                title
                description
                url
              }
            }
          }
        }
      }
    }
  }
`
export default QUERY
